/**
 * Created by Rakesh Peela
 * Date: 15-Feb-2020
 * Time: 12:33 AM
 */

export const GET_DOWNLOADABLE = "GET_DOWNLOADABLE";
export const GET_DOWNLOADABLE_PENDING = "GET_DOWNLOADABLE_PENDING";
export const GET_DOWNLOADABLE_FAILED = "GET_DOWNLOADABLE_FAILED";
